import { useRef } from "react";
import { useMapApi } from "./hooks";
import { isTour } from "lib/predicates";
import { debug } from "./debug";

const log = debug("log");

export const Map = ({
  item,
  elpro,
}: {
  item: Travelguide.POI | Travelguide.Tour;
  elpro: boolean;
}) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const api = useMapApi("oax");

  if (api && mapRef.current && !window.oaMapContainerInitialized) {
    log("Map api loaded, continuing to initialize..");
    window.oaMapContainerInitialized = true;

    const center = isTour(item)
      ? { lat: item.startingPoint.lat, lng: item.startingPoint.lng }
      : { lat: item.geometry.lat, lng: item.geometry.lng };

    const layer = api.geomLayer(item.id, {
      [isTour(item) ? "fitTourBounds" : "fitPoiBounds"]: true,
      markersActive: false,
      defaultIW: false,
    });

    layer.whenLoaded(() => {
      if (!mapRef.current) {
        console.error("Error: map was unloaded");
        return;
      }

      log("Initializing map..");

      const map = api.map(mapRef.current, {
        zoom: 10,
        scrollwheel: false,
        mapInit: {
          basemap: "osm",
          overlay: "slope",
        },
        bounds: layer.getBounds(),
        center,
      });
      layer.setMap(map);
    });
  }

  return (
    <section>
      <div ref={mapRef} id="map-layer" className="relative z-0 h-96"></div>
      {elpro && <div id="oax-api-elpro" className="relative z-0"></div>}
    </section>
  );
};
